import { Group } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import ButtonItem from './ButtonItem';

export interface GroupButtonItem {
  icon?: React.ComponentType;
  title?: string;
  subtitle?: string;
  value?: string | number;
}

// Extend from React's HTMLAttributes but omit onChange to avoid type conflicts
interface GroupButtonProps extends Omit<React.ComponentPropsWithoutRef<'div'>, 'onChange'> {
  onChange: (_value: string | number) => void;
  options: GroupButtonItem[];
  defaultValue?: string | number;
  name?: string; // Explicitly add name prop since it's used in ModalAddActivity
  id?: string; // Common attribute to include explicitly
  className?: string; // Common attribute to include explicitly
  type?: 'default' | 'compact';
}

const GroupButton: React.FC<GroupButtonProps> = ({
  onChange,
  defaultValue,
  options,
  className,
  type = 'default',
  ...props
}) => {
  const [selected, setSelected] = useState<string | number>('');

  useEffect(() => {
    setSelected(defaultValue ?? '');
  }, [defaultValue]);

  const handleClick = (value: string | number) => {
    if (selected === value) {
      setSelected('');
      onChange && onChange('');
      return;
    }
    onChange && onChange(value);
    setSelected(value);
    return;
  };

  return (
    <div className={className}>
      <Group wrap='nowrap' {...props}>
        {options.map((item, index) => (
          <ButtonItem
            key={index}
            onClick={handleClick}
            icon={item.icon}
            title={item.title}
            subtitle={item.subtitle}
            value={item.value}
            active={selected === item.value}
            type={type}
          />
        ))}
      </Group>
    </div>
  );
};

export default GroupButton;
